import RequestAdapter from '../adapters/RequestAdapter';
import { V2_AUTH_PATH_BASE, API_V3_PATH_BASE } from '../constants';
import { ENDPOINTS } from '../enums/endpoints';

const CryptoJS = require('crypto-js');
const soapKey = 'soap-key-98476dtfe654';
Object.freeze(soapKey);

const login = (formData) => {
  const requestConfig = {
    url: `${API_V3_PATH_BASE}${ENDPOINTS.AUTHENTICATION.LOGIN}`,
    method: 'POST',
    body: JSON.stringify(formData),
  };

  return RequestAdapter.externalRequest(requestConfig);
};

const recoverPassword = (formData) => {
  const requestConfig = {
    url: `${API_V3_PATH_BASE}${ENDPOINTS.AUTHENTICATION.RECOVER_PASSWORD}`,
    method: 'POST',
    body: JSON.stringify(formData),
  };

  return RequestAdapter.externalRequest(requestConfig);
};

const updatePassword = (formData) => {
  const requestConfig = {
    url: `${API_V3_PATH_BASE}${ENDPOINTS.AUTHENTICATION.RESET_PASSWORD}`,
    method: 'POST',
    body: JSON.stringify(formData),
  };

  return RequestAdapter.externalRequest(requestConfig);
};

const createSession = (formData) => {
  const requestConfig = {
    url: `${V2_AUTH_PATH_BASE}${ENDPOINTS.AUTHENTICATION.SESSION}?language=pt`,
    method: 'POST',
    body: JSON.stringify({ ...formData, remember_me: '1' }),
  };

  return RequestAdapter.externalRequest(requestConfig);
};

const send2FACode = (formData) => {
  const { userId, ...form } = formData;

  const requestConfig = {
    url: `${API_V3_PATH_BASE}${ENDPOINTS.AUTHENTICATION.TWO_FACTOR_AUTHENTICATION(
      userId
    )}`,
    method: 'POST',
    body: JSON.stringify(form),
  };

  return RequestAdapter.externalRequest(requestConfig);
};

const sendEmailWith2FACode = (formData) => {
  const { userId } = formData;

  const requestConfig = {
    url: `${API_V3_PATH_BASE}${ENDPOINTS.AUTHENTICATION.TWO_FACTOR_AUTHENTICATION_EMAIL(userId)}`,
    method: 'POST',
    body: JSON.stringify(formData),
  };

  return RequestAdapter.request(requestConfig);
};

const encryptWithAES = (text) => {
  return CryptoJS.AES.encrypt(text, soapKey).toString();
};

const decryptWithAES = (encryptedText) => {
  const bytes = CryptoJS.AES.decrypt(encryptedText, soapKey);
  return bytes.toString(CryptoJS.enc.Utf8);
};

export const AuthenticationService = {
  login,
  send2FACode,
  sendEmailWith2FACode,
  createSession,
  recoverPassword,
  updatePassword,

  encryptWithAES,
  decryptWithAES,
};
